<template>
    <transition
        enter-active-class="transition duration-500 ease-linear"
        enter-class="translate-y-1/2 opacity-0"
        enter-to-class="translate-y-0 opacity-100"
        leave-active-class="transition duration-500 ease-linear"
        leave-class="translate-y-0 opacity-100"
        leave-to-class="translate-y-1/2 opacity-0"
    >
        <div v-show="open" id="popup" class="fixed bottom-0 right-0 z-30 hidden mb-8 mr-8 lg:block">
            <div class="flex items-center w-full max-w-lg p-4 bg-gray-100 border border-gray-200 rounded-lg shadow-xl">
                <button
                    class="absolute top-0 right-0 flex items-center justify-center w-6 h-6 -mt-3 -mr-3 text-white rounded-full shadow-lg bg-brand-green"
                    type="button"
                    @click="closeModal"
                >
                    <i class="fa fa-times"></i>
                </button>
                <div v-if="imageSrc" class="w-1/4">
                    <img :src="imageSrc" alt="popup image" class="rounded">
                    <div class="pt-2 text-sm text-center">
                        <slot name="image-caption"></slot>
                    </div>
                </div>
                <div class="w-3/4">
                    <div class="pt-1 text-base font-light text-black">
                        <div>
                            <span class="absolute top-0 m-2 font-serif text-gray-300 opacity-50 text-9xl">“</span>
                            <slot name="body"></slot>
                        </div>
                    </div>
                    <div class="pt-2 text-base font-bold text-gray-700 ml-7">
                        <a id="popup-cta-link" class="underline text-brand-blue hover:text-brand-blue-light" href="#form" @click="footerLinkClick"><slot name="footer-link"></slot> ></a>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import {mapGetters} from "vuex";

export default {

    props: {
        imageSrc: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            open: false,
            observer: null,
        }
    },

    computed: {
        ...mapGetters('meta', [
            'popupIsEnabled',
        ]),
    },

    methods: {
        closeModal() {
            this.observer.unobserve(document.querySelector('#hero-primary'));
            this.open = false;
        },

        footerLinkClick() {
            this.closeModal();
            // this.open = false;
            setTimeout(()=>{
                document.getElementById('inputLocation').focus();
            }, 1000);
        }
    },

    watch: {
        popupIsEnabled(value) {
            if (value === false) {
                this.open = false;
            }
        }
    },

    mounted() {
        // We use the IntersectionObserver API to show the Popup
        // after the user scrolls down and the hero section leaves the viewport.
        if (IntersectionObserver != undefined) {
            this.observer = new IntersectionObserver(
                (entries, observer) => {
                    if (this.popupIsEnabled === false) {
                        this.open = false;

                        return;
                    }

                    if ( ! entries[0].isIntersecting) {
                        this.open = true;
                    }
                    else {
                        this.open = false;
                    }
                },
                {
                    threshold: 0
                }
            );

            this.observer.observe(document.querySelector('#hero-primary'));
        }
    }

}
</script>
